import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faApple,
  faAndroid,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

library.add(faApple, faAndroid, faYoutube)
